import { ReactNode } from "react";

export {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
};

function ConfigurationPanelHeader({ children }: { children: ReactNode }) {
  return (
    <div className="px-4 py-4 flex items-center justify-between shrink-0 rounded-t-xl shadow-sm">
      {children}
    </div>
  );
}

function ConfigurationPanelBody({ children }: { children: ReactNode }) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-6 py-4 shadow-sm">
      {children}
    </div>
  );
}

function ConfigurationPanelFooter({ children }: { children: ReactNode }) {
  return <div className="px-4 py-3 shrink-0 rounded-b-xl">{children}</div>;
}

function ConfigurationPanel({ children }: { children: ReactNode }) {
  return (
    <div className="absolute right-2 top-2 bottom-2 w-[450px] z-10">
      <div className="h-full border rounded-xl flex flex-col bg-white shadow-lg">
        {children}
      </div>
    </div>
  );
}
